/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
import{generateUID as o}from"../../../../core/uid.js";class r{constructor(r){this.channel=r,this.id=o()}}export{r as Object3DStateID};
